import { isAbortError } from 'shared/utils/errorHandling';
import { isChannelRequestError } from './errors';

/**
 * What a worker's read rejects with when the data it was reading was replaced
 * while it ran (a project switch): the read is cancelled, not failed.
 */
export const DATA_REPLACED_MESSAGE = 'The project changed during the download';

/** What a browser puts in the abort of a request, which reaches the page as the message of the worker's error. */
const ABORT_MESSAGE_PREFIX = 'signal is aborted';

/** A read whose data was replaced while it ran (a project switch): cancelled, not failed. */
export class DataReplacedError extends Error {
  constructor() {
    super(DATA_REPLACED_MESSAGE);
    this.name = 'DataReplacedError';
  }
}

/** A cancellation as it reaches the page: only its message crossed the channel. */
function isCancellationFromWorker(error: unknown): boolean {
  return (
    isChannelRequestError(error) &&
    (error.message === DATA_REPLACED_MESSAGE || error.message.startsWith(ABORT_MESSAGE_PREFIX))
  );
}

/**
 * Whether a request ended because it was cancelled (aborted, or its data
 * replaced), not because it failed: nobody needs a failure report for it.
 * Reads the error where it was thrown (the worker) and where it arrived (the page).
 */
export function isCancelledRequest(error: unknown): boolean {
  return isAbortError(error) || error instanceof DataReplacedError || isCancellationFromWorker(error);
}
